<template>
    <div :class="apenas_links ? '' : 'btn-group dropleft'" v-if="relatorios.length || ( outros && outros.length )">
        <button class="btn btn-outline-primary btn-sm dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="!apenas_links">
            <i class="fa fa-print ml-1" aria-hidden="true"></i>
        </button>

        <div class="dropdown-divider" v-if="apenas_links"></div>
        
        <div :class="apenas_links ? '' : 'dropdown-menu'" aria-labelledby="triggerId">
            <template v-if="outros">
                <button 
                    class="dropdown-item" type="button" 
                    v-for="(outro, iox) in outros" :key="'o' + iox" 
                    @click="outro.callback ()">
                    {{ outro.title }}
                </button>
            </template>
            <a href="#" @click.prevent="abrir_relatorio(relatorio)" class="dropdown-item" v-for="(relatorio, irx) in relatorios" :key="'r' + irx">
                {{ relatorio.title }}
            </a>
            
            <!--
            <router-link
                v-for="(relatorio, irx) in relatorios" :key="'r' + irx"
                :to="{ name: 'relatorio', params: { id: relatorio.id, ...parms, breadcrumb: $store.state.breadcrumb, linked: true } }"
                class="dropdown-item">
                {{ relatorio.title }}
            </router-link>
            -->
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data () { 
        return { 
            relatorios: [],
        }
    },

    props: ['pagina', 'parms', 'outros', 'apenas_links'],

    methods: { 
        abrir_relatorio (relatorio) { 
            this.$root.$children[0].$refs.relatmodal.abrir({ id: relatorio.id, ...this.parms, inmodal: true, linked: true });
        }
    },

    mounted () { 
        let info = _.get(this.$store.state.relatorios_linkados, this.pagina);

        if ( info ) { 
            this.relatorios = info; 
            return;
        } 

        this.$util.loadItem(this, {
            service: "relatorios",
            func: "pagina",
            parms: {
                pagina: this.pagina
            }
        })
        .then(res => {
            let info = {};

            this.relatorios = res.map (item => item._query);

            info[this.pagina] = this.relatorios;

            this.$store.commit("setRelatorioLinkado", info);
        });
    }
}
</script>